<aside class="sticky top-0 flex h-dvh flex-col justify-center gap-10 bg-linear-to-br from-brand-studio-dark to-brand-studio px-10 text-white">
  <p class="m-0 text-sm font-bold uppercase tracking-widest">{{ label() }}</p>
  <article class="max-w-md overflow-hidden rounded-xl bg-card text-foreground shadow-xl">
    @if (filled() && onboarding.draft().agency?.bannerUrl) {
      <img [src]="onboarding.draft().agency?.bannerUrl" alt="" class="h-16 w-full object-cover lg:h-24" />
    } @else {
      <div class="h-16 bg-linear-to-br from-brand-deep-purple to-primary lg:h-24"></div>
    }
    <div class="flex flex-col gap-4 px-6 pb-6">
      <div class="flex items-center gap-3 pt-5">
        @if (filled()) {
          <div class="flex shrink-0 items-center justify-center overflow-hidden rounded-lg border-4 border-card bg-linear-to-br from-brand-studio-dark to-brand-studio text-xl font-black text-white shadow-sm">
            @if (onboarding.draft().agency?.logoUrl) {
              <img [src]="onboarding.draft().agency?.logoUrl" alt="" class="size-14 rounded-lg object-contain" />
            } @else {
              <div class="flex size-14 items-center justify-center rounded-lg text-xl font-black text-white">
                {{ initial() }}
              </div>
            }
          </div>
          <div class="min-w-0 flex-1">
            <p class="m-0 text-2xl font-semibold text-foreground">{{ onboarding.agencyName() }}</p>
            <p class="m-0 text-base text-muted-foreground">{{ onboarding.draft().agency?.domain || 'Added manually' }}</p>
          </div>
        } @else {
          <div class="size-14 shrink-0 rounded-lg bg-muted"></div>
          <div class="min-w-0 flex-1">
            <div class="mb-2 h-3.5 w-3/5 rounded bg-muted"></div>
            <div class="h-2.5 w-2/5 rounded bg-muted"></div>
          </div>
        }
      </div>

      @if (filled()) {
        <div class="flex flex-wrap gap-2">
          <p class="m-0 rounded-full bg-primary/10 px-3 py-1 text-sm font-bold text-accent">Agency</p>
          <p class="m-0 rounded-full bg-primary/10 px-3 py-1 text-sm font-bold text-accent">{{ onboarding.activeCurrency() }}</p>
          <p class="m-0 rounded-full bg-primary/10 px-3 py-1 text-sm font-bold text-accent">{{ brandCountLabel() }}</p>
        </div>
      } @else {
        <div class="flex flex-col gap-2">
          <div class="h-2.5 w-full rounded bg-muted"></div>
          <div class="h-2.5 w-4/5 rounded bg-muted"></div>
        </div>
        <p class="m-0 text-base font-medium text-muted-foreground">Enter your website to see your workspace.</p>
      }

      <div>
        <p class="m-0 text-sm font-bold uppercase tracking-widest text-muted-foreground">Brands</p>
        <ul class="m-0 mt-2 list-none p-0">
          @for (slot of slots; track slot) {
            <li class="flex h-12 items-center gap-3 border-t border-border">
              @if (slotBrand(slot); as brand) {
                @if (brand.status === 'loading') {
                  <span class="size-8 shrink-0 rounded-lg bg-muted" aria-hidden="true"></span>
                  <p class="m-0 text-base font-semibold text-muted-foreground">Finding brand…</p>
                } @else if (brand.logoUrl) {
                  <img [src]="brand.logoUrl" alt="" class="size-8 shrink-0 rounded-lg bg-muted object-cover" />
                  <div class="min-w-0">
                    <p class="m-0 truncate text-lg font-bold">{{ brand.name }}</p>
                    <p class="m-0 truncate text-sm font-semibold text-muted-foreground">{{ domainLabel(brand.domain) }}</p>
                  </div>
                } @else {
                  <span class="flex size-8 shrink-0 items-center justify-center rounded-lg bg-linear-to-br from-brand-agency-dark to-brand-agency text-xs font-black text-white" aria-hidden="true">{{ brandInitial(brand.name) }}</span>
                  <div class="min-w-0">
                    <p class="m-0 truncate text-lg font-bold">{{ brand.name }}</p>
                    <p class="m-0 truncate text-sm font-semibold text-muted-foreground">{{ domainLabel(brand.domain) }}</p>
                  </div>
                }
              } @else {
                <span class="size-8 shrink-0 rounded-lg border border-dashed border-border" aria-hidden="true"></span>
                <p class="m-0 text-base font-semibold text-muted-foreground">Brand slot {{ slot + 1 }} of 3</p>
              }
            </li>
          }
        </ul>
      </div>

      <div class="flex items-center justify-between border-t border-border pt-3">
        <p class="m-0 text-base font-bold">{{ ownerLabel() }}</p>
        <p class="m-0 rounded-full px-3 py-1 text-sm font-bold" [class]="status().live ? 'bg-emerald-50 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-200' : 'bg-primary/10 text-accent'">
          {{ status().label }}
        </p>
      </div>
    </div>
  </article>
  <div>
    <p class="m-0 text-base font-semibold">Trusted by the world's most innovative teams</p>
    <div class="mt-6 flex flex-wrap items-center justify-between gap-x-6 gap-y-4">
      <img src="../../../../../assets/logos/cloud/adobe_dark.svg" alt="Adobe" class="h-8 w-auto brightness-0 invert xl:h-10" />
      <img src="../../../../../assets/logos/cloud/byd_dark.svg" alt="BYD" class="h-4 w-auto brightness-0 invert xl:h-5" />
      <img src="../../../../../assets/logos/cloud/golin_dark.svg" alt="GOLIN" class="h-5 w-auto brightness-0 invert xl:h-7" />
      <img src="../../../../../assets/logos/cloud/pizzahut_dark.svg" alt="Pizza Hut" class="h-5 w-auto brightness-0 invert xl:h-6" />
      <img src="../../../../../assets/logos/cloud/monday_dark.svg" alt="monday.com" class="h-4 w-auto brightness-0 invert xl:h-5" />
    </div>
  </div>
</aside>
